import { Product } from '../types/product';

export const products: Product[] = [
  {
    id: 'trading',
    title: 'TRADING',
    description: 'trading_description' ,
    type: 'TRADING',
    calculatorDefaults: {
      initialInvestment: 50,
      dailyPercentage: 0.055,
      monthlyPercentage: 23.59,
      quarterlyPercentage: 70.05,
      yearlyPercentage: 284.95
    },
    pdfUrl: 'pdf_trading_name'
  },
  {
    id: 'staking',
    title: 'STAKING',
    description: 'staking_description',
    type: 'STAKING',
    calculatorDefaults: {
      initialInvestment: 500,
      dailyPercentage: 0.055,
      monthlyPercentage: 23.59,
      quarterlyPercentage: 70.05,
      yearlyPercentage: 284.95
    },
    pdfUrl: 'pdf_staking_name'
  },
  {
    id: 'thorchain',
    title: 'THORCHAIN NODES',
    description: 'thornchain_description',
    type: 'THORCHAIN_NODES',
    calculatorDefaults: {
      initialInvestment: 500,
      dailyPercentage: 0.055,
      monthlyPercentage: 23.59,
      quarterlyPercentage: 70.05,
      yearlyPercentage: 284.95
    },
    pdfUrl: 'pdf_thorchain_name'
  },
  {
    id: 'cannabis',
    title: 'CANNABIS',
    description: 'cannabis_description',
    type: 'CANNABIS',
    calculatorDefaults: {
      initialInvestment: 0,
      dailyPercentage: 0.055,
      monthlyPercentage: 23.59,
      quarterlyPercentage: 70.05,
      yearlyPercentage: 284.95
    },
    pdfUrl: '../assets/pdf/cannabis.pdf'
  },
  {
    id: 'casino',
    title: 'CASINO',
    description: 'casino_description',
    type: 'CASINO',
    calculatorDefaults: {
      initialInvestment: 0,
      dailyPercentage: 0.055,
      monthlyPercentage: 23.59,
      quarterlyPercentage: 70.05,
      yearlyPercentage: 284.95
    },
    pdfUrl: '../assets/pdf/casino.pdf'
  }
];